(function () {
  var routeMap = {
    '/pages/electrical-steel-products': '/pages/wancheng-electrical-steel-products',
    '/pages/mother-coil': '/pages/wancheng-mother-coil',
    '/pages/slitting-coil': '/pages/wancheng-slitting-coil',
    '/pages/transformer-core': '/pages/wancheng-transformer-core'
  };
  var desktopHtml = '<a href="/">Home</a><a href="/pages/about-us">About us</a><details class="mh-site-nav__dropdown"><summary>Products</summary><div><a href="/pages/wancheng-electrical-steel-products">Product Overview</a><a href="/pages/wancheng-mother-coil">Mother Coil</a><a href="/pages/wancheng-slitting-coil">Slitting Coil</a><a href="/pages/lamination">Lamination</a><a href="/pages/wancheng-transformer-core">Transformer Core</a></div></details><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
  var mobileHtml = '<a href="/">Home</a><a href="/pages/about-us">About us</a><a href="/pages/wancheng-electrical-steel-products">Product Overview</a><a href="/pages/wancheng-mother-coil">Mother Coil</a><a href="/pages/wancheng-slitting-coil">Slitting Coil</a><a href="/pages/lamination">Lamination</a><a href="/pages/wancheng-transformer-core">Transformer Core</a><a href="/pages/news">News</a><a href="/pages/request-a-quote">Contact us</a>';
  var oldPattern = /\/pages\/(electrical-steel-products|mother-coil|slitting-coil|transformer-core)([?#][^"']*)?/;

  function rewrittenHref(href) {
    if (!href) return href;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }
    if (url.origin !== window.location.origin) return href;
    var targetPath = routeMap[url.pathname.replace(/\/$/, '')];
    if (!targetPath) return href;
    return targetPath + (url.hash || '');
  }

  function rewriteLegacyLinks(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href], area[href]').forEach(function (link) {
      var current = link.getAttribute('href');
      var next = rewrittenHref(current);
      if (next && next !== current) {
        link.setAttribute('href', next);
      }
    });
    root.querySelectorAll('template').forEach(function (template) {
      rewriteLegacyLinks(template.content);
    });
  }

  function restoreProductNavigation() {
    var desktopNav = document.querySelector('.mh-site-menu, .mh-site-nav');
    if (desktopNav && (!desktopNav.querySelector('.mh-site-nav__dropdown') || oldPattern.test(desktopNav.innerHTML))) {
      desktopNav.innerHTML = desktopHtml;
    }
    var mobileNav = document.querySelector('.mh-site-mobile__panel');
    if (mobileNav && (!mobileNav.querySelector('a[href="/pages/wancheng-mother-coil"]') || oldPattern.test(mobileNav.innerHTML))) {
      mobileNav.innerHTML = mobileHtml;
    }
  }

  function applyWanchengNavigationFixes() {
    restoreProductNavigation();
    rewriteLegacyLinks(document);
  }

  applyWanchengNavigationFixes();
  document.addEventListener('DOMContentLoaded', applyWanchengNavigationFixes);
  window.addEventListener('load', applyWanchengNavigationFixes);
  [100, 500, 1500, 3000, 6000, 10000, 15000].forEach(function (delay) {
    setTimeout(applyWanchengNavigationFixes, delay);
  });

  if ('MutationObserver' in window) {
    var navRestoreTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(navRestoreTimer);
      navRestoreTimer = setTimeout(applyWanchengNavigationFixes, 50);
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      });
    }
  }
})();
